import type { StudioApi } from '../engine/api';

export function errorMessage(error: unknown): string {
  if (error instanceof Error && error.message) return error.message;
  if (typeof error === 'string' && error) return error;
  return 'Something went wrong.';
}

/**
 * Run a command or studio call so that a thrown error or rejected promise
 * becomes an error toast instead of an unhandled rejection.
 */
export async function safely<T>(
  studio: Pick<StudioApi, 'notify'>,
  work: () => T | Promise<T>,
  prefix?: string,
): Promise<T | undefined> {
  try {
    return await work();
  } catch (error) {
    studio.notify('error', prefix ? `${prefix}: ${errorMessage(error)}` : errorMessage(error));
    return undefined;
  }
}

/** Synchronous variant for commands, which throw user-presentable errors. */
export function attempt<T>(studio: Pick<StudioApi, 'notify'>, work: () => T): T | undefined {
  try {
    return work();
  } catch (error) {
    studio.notify('error', errorMessage(error));
    return undefined;
  }
}
